import { authoredFormsSchema, publishFormSchema, type PublishForm } from '@vigeo/shared';
import { fixtureMode } from '@/lib/data-mode';
export async function fetchForms() {
  if (fixtureMode) return { forms: [] };
  const response = await fetch('/api/catalog/forms');
  if (!response.ok) throw new Error('Forms could not be loaded.');
  return authoredFormsSchema.parse(await response.json());
}
export async function publishForm(input: PublishForm) {
  if (fixtureMode) throw new Error('Publishing is unavailable in the design preview.');
  const response = await fetch('/api/catalog/forms', { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify(publishFormSchema.parse(input)) });
  const result = await response.json() as { error?: string };
  if (!response.ok) throw new Error(result.error ?? 'The form could not be published.');
  return result;
}
